import axiosClient from './axiosClient';

export interface LoginPayload {
  email: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
}

export interface UserProfileResponse {
  id: number;
  name: string;
  email: string;
  company_id: number | null;
  department_id: number | null;
  is_active: boolean;
  role_id: number;
  created_at: string;
  role_name: string | null;
  company_name: string;
  department_name: string;
}

export const login = async (payload: LoginPayload): Promise<LoginResponse> => {
  const response = await axiosClient.post('/auth/login', payload);
  return response.data;
};

export const getUserProfile = async (
  token: string
): Promise<UserProfileResponse> => {
  const response = await axiosClient.get('/auth/me', {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

// Refresh token API
export const refreshTokens = async (
  refreshToken: string
): Promise<LoginResponse> => {
  const response = await axiosClient.post('/auth/refresh', {
    refresh_token: refreshToken
  });
  return response.data;
};

// Logout API
export const logout = async (accessToken: string): Promise<void> => {
  await axiosClient.post(
    '/auth/logout',
    {},
    {
      headers: { Authorization: `Bearer ${accessToken}` }
    }
  );
};

// Change Password (Authenticated)
export interface ChangePasswordPayload {
  current_password: string;
  new_password: string;
  confirm_password: string;
}

export interface ChangePasswordResponse {
  message: string;
}

export const changePassword = async (
  payload: ChangePasswordPayload,
  accessToken: string
): Promise<ChangePasswordResponse> => {
  const response = await axiosClient.post('/auth/change-password', payload, {
    headers: { Authorization: `Bearer ${accessToken}` }
  });
  return response.data;
};

// Forgot Password
export interface ForgotPasswordPayload {
  email: string;
}

export interface ForgotPasswordResponse {
  message: string;
}

export const forgotPassword = async (
  payload: ForgotPasswordPayload
): Promise<ForgotPasswordResponse> => {
  const response = await axiosClient.post('/auth/forgot-password', payload);
  return response.data;
};

// Reset Password
export interface ResetPasswordPayload {
  token: string;
  new_password: string;
  confirm_password: string;
}

export interface ResetPasswordResponse {
  message: string;
}

export const resetPassword = async (
  payload: ResetPasswordPayload
): Promise<ResetPasswordResponse> => {
  const response = await axiosClient.post('/auth/reset-password', payload);
  return response.data;
};
